"use client";

import { CommunicationsCompanyDisplay } from "./CommunicationsDetailTabComponents/CommunicationsCompanyDisplay";
import { CommunicationsContactDisplay } from "./CommunicationsDetailTabComponents/CommunicationsContactDisplay";
import { CommunicationsDetailsDisplay } from "./CommunicationsDetailTabComponents/CommunicationsDetailsDisplay";
import { CommunicationsMetadataDisplay } from "./CommunicationsDetailTabComponents/CommunicationsMetadataDisplay";
import { CommunicationsDealsDisplay } from "./CommunicationsDetailTabComponents/CommunicationsDealsDisplay";
import { CommunicationsTasksDisplay } from "./CommunicationsDetailTabComponents/CommunicationsTasksDisplay";
import { CommunicationsRelatedActivitiesDisplay } from "./CommunicationsDetailTabComponents/CommunicationsRelatedActivitiesDisplay";
import { CommunicationsTimelineDisplay } from "./CommunicationsDetailTabComponents/CommunicationsTimelineDisplay";

// ============================================================================
// EXPORT ALL TAB COMPONENTS
// ============================================================================

export const CommunicationsDetailTabComponents = {
  CommunicationsDetailsDisplay,
  CommunicationsCompanyDisplay,
  CommunicationsContactDisplay,
  CommunicationsDealsDisplay,
  CommunicationsTasksDisplay,
  CommunicationsRelatedActivitiesDisplay,
  CommunicationsTimelineDisplay,
  CommunicationsMetadataDisplay,
};
